import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PillButton from '../../../global/Button/PillButton';

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  margin: 14px 0;
  padding: 10px 0;
  overflow-x: auto;
`;

const StyledButton = styled(PillButton)`
  background-color: ${p =>
    p.show ? p.theme.color.primary : p.theme.color.tertiary};
  border: 2px solid
    ${props =>
    props.show
      ? props.theme.color.primary
      : props.theme.color.borderPrimaryDarkened};
  color: ${p =>
    p.show ? p.theme.color.tertiary : p.theme.color.headerSecondary};
`;

const AccordionTabs = ({ sections, handleClick, active }) => (
  <Container>
    {sections.map((section, index) => (
      <StyledButton
        key={index}
        show={active === index}
        onClick={() => handleClick(index)}
      >
        {section.categoryName}
      </StyledButton>
    ))}
  </Container>
);

AccordionTabs.propTypes = {
  sections: PropTypes.array,
  active: PropTypes.number,
  handleClick: PropTypes.func
};
export default AccordionTabs;
